<style lang="stylus">
        .focus-expand-box
            position absolute
            left 0
            top 0
            width 100vw
            height 100vh
            z-index 10
            pointer-events none

            .focus-expand-tool
                position fixed
                left 200px
                top 200px
                width 56px
                padding 0 8px
                z-index 10
                box-shadow $box-shadow
                border-radius 5px
                background  var(--bg-color-tertiary)
                pointer-events auto

                .expand-tool-title
                    height 8px
                    cursor pointer
                    user-select none
                    display flex
                    justify-content center
                    align-items center

                    div
                        width 12px
                        height 8px

                        &::after
                            display block
                            content ''
                            width 12px
                            height 1px
                            background #cccccc
                            margin-top 3px

                        &::before
                            display block
                            content ''
                            width 12px
                            height 1px
                            background #cccccc
                            margin-top 3px
                .expand-tool-box
                    position relative
                    width 40px
                    height 40px
                    cursor pointer
                    user-select none
                    border-radius 6px
                    &.expand-ban-btn:not(.active)
                        opacity .2
                        pointer-events none

                    svg
                        width 40px
                        height 40px
                        pointer-events none
                        color: var(--svg-color-gray-42)
                        fill var(--svg-color-gray-75)

                    &:hover
                        background rgba(0, 0, 0, 0.06);


                .expand-tool-expand
                    .active
                        transform rotate(180deg)


                .expand-tool-content
                    .expand-tool-btn
                        &.active
                            // background var(--box-shadow-color-expand-drop)
                            background rgba(0, 0, 0, 0.08);
                        &:last-child
                            &:before
                                content ""
                                height 1px
                                width 80%
                                margin auto
                                background var(--border-color-focus-tool)
                                display block

    .focus-expand-fontbox
        position absolute
        left 0
        top 36px
        width 56px
        padding 8px
        border-radius 5px
        box-shadow $common-box-shadow
        cursor default
        user-select none
        pointer-events auto
        background var(--bg-color-tertiary)
        display flex
        flex-wrap wrap
        div
            width 40px
            height 40px
            cursor pointer
            &:hover
                background var(--bg-color-focus-tool-box-hover)
            svg
                width 40px
                height 40px
                pointer-events none
                color: var(--svg-color-gray-42)
                fill var(--svg-color-gray-75)
    .item-color
        pointer-events none
        position absolute
        margin-left 10px
        bottom 5px
        border-radius 3px
        width 18px
        height 3px
</style>

<template>
    <div class="focus-expand-box" v-show="!expandLeft && !expandTop">
        <div class="focus-expand-tool" ref="expandTool" :style="`height: ${boxHeight}px;left:${toolLeft}px;top:${toolTop}px`">
            <div class="expand-tool-title" ref="expandToolTitle">
                <div></div>
            </div>
            <div class="expand-tool-expand expand-tool-box" @click="expandBox">
                <iconSymbol :class="{ active: !expandStatus }" name="focustool-expand" />
            </div>
            <div class="expand-tool-content" v-show="expandStatus">
                <div
                    class="expand-tool-btn expand-tool-box"
                    :class="{
                        active: item.active || getColorActive(item.id),
                        'expand-ban-btn': !isSelect && item.id != 1 && item.id != 10 && item.id != 2,
                    }"
                    v-for="item in list"
                    :key="item.id"
                    :ref="item.name"
                    :content="isSdk && item.id === 10 ? $t('more') : $t(item.name)"
                    v-tippy="{ placement: 'bottom' }"
                    @click="clickBox(item, $event)"
                >
                    <template v-if="isSdk">
                        <iconSymbol :name="`sdk-focustool-icon${item.id}`" />
                    </template>
                    <iconSymbol v-else :name="`focustool-icon${item.id}`" />
                    <div v-if="item.id == 3" class="item-color" :style="{ backgroundColor: fontColor }"></div>
                    <div v-if="item.id == 5" class="item-color" :style="{ backgroundColor: fillColor }"></div>
                    <div v-if="item.id == 6" class="item-color" :style="{ backgroundColor: lineColor }"></div>
                </div>
            </div>
        </div>
        <FocusExpandToolShape
            :index="0"
            :dragTitle="$t('shape')"
            :showModal="list[0].active"
            :originPostion="list[0].originPostion"
            :lockBox="list[0].lock"
            @changeLock="changeLock($event)"
            @updateBoxPos="updateBoxPos($event, 0)"
            @stopCloseEvent="stopCloseEvent($event)"
            @removeCloseEvent="removeCloseListener()"
            @closeBox="closeEvent($event)"
        />
        <FocusExpandToolText
            :index="1"
            :dragTitle="$t('text')"
            :showModal="list[1].active"
            :originPostion="list[1].originPostion"
            :lockBox="list[1].lock"
            @changeLock="changeLock($event)"
            @updateBoxPos="updateBoxPos($event, 1)"
            @stopCloseEvent="stopCloseEvent($event)"
            @removeCloseEvent="removeCloseListener()"
            @closeBox="closeEvent($event)"
        />
        <!-- <div
            class="focus-expand-fontbox"
            :style="{ left: `${list[1].originPostion.left}px`, top: `${list[1].originPostion.top}px` }"
            v-if="list[1].active"
        >
            <div @click.stop="addTextSize">
                <iconSymbol name="focustool-icon2-1" />
            </div>
            <div @click.stop="reduceTextSize">
                <iconSymbol name="focustool-icon2-2" />
            </div>
        </div> -->
        <FocusExpandToolTextAlign
            :index="3"
            :dragTitle="$t('textAlign')"
            :showModal="list[3].active"
            :originPostion="list[3].originPostion"
            :lockBox="list[3].lock"
            @changeLock="changeLock($event)"
            @updateBoxPos="updateBoxPos($event, 3)"
            @removeCloseEvent="removeCloseListener()"
            @closeBox="closeEvent($event)"
        />
        <FocusExpandToolLayer
            :index="6"
            :dragTitle="$t('layer')"
            :showModal="list[6].active"
            :originPostion="list[6].originPostion"
            :lockBox="list[6].lock"
            @changeLock="changeLock($event)"
            @updateBoxPos="updateBoxPos($event, 6)"
            @removeCloseEvent="removeCloseListener()"
            @closeBox="closeEvent($event)"
        />
        <FocusExpandToolShapeAlign
            :index="7"
            :dragTitle="$t('shapeAlign')"
            :showModal="list[7].active"
            :originPostion="list[7].originPostion"
            :lockBox="list[7].lock"
            @changeLock="changeLock($event)"
            @updateBoxPos="updateBoxPos($event, 7)"
            @removeCloseEvent="removeCloseListener()"
            @closeBox="closeEvent($event)"
        />
        <FocusExpandToolPosition
            ref="positionBox"
            :index="8"
            :dragTitle="$t('position')"
            :showModal="list[8].active"
            :originPostion="list[8].originPostion"
            :lockBox="list[8].lock"
            @changeLock="changeLock($event)"
            @updateBoxPos="updateBoxPos($event, 8)"
            @removeCloseEvent="removeCloseListener()"
            @closeBox="closeEvent($event)"
        />
    </div>
</template>

<script lang="ts">
    declare var UnitUtil: any;
    declare var eUnit: any;
    declare var EDChart: any;
    import { Component, Prop, Inject, Vue } from "vue-property-decorator";
    import FocusExpandToolShape from "./FocusExpandToolShape.vue";
    import FocusExpandToolTextAlign from "./FocusExpandToolTextAlign.vue";
    import FocusExpandToolLayer from "./FocusExpandToolLayer.vue";
    import FocusExpandToolShapeAlign from "./FocusExpandToolShapeAlign.vue";
    import FocusExpandToolPosition from "./FocusExpandToolPosition.vue";
    import FocusExpandToolText from "./FocusExpandToolText.vue";
    import fontTool from "@/app/mixin/fontTool";

    @Component({
        components: {
            FocusExpandToolShape,
            FocusExpandToolText,
            FocusExpandToolTextAlign,
            FocusExpandToolLayer,
            FocusExpandToolShapeAlign,
            FocusExpandToolPosition,
        },
    })
    export default class FocusExpandTool extends fontTool {
        @Inject()
        ["showMessage"];
        attr: object = { left: 0, top: 0 };
        toolLeft = 70;
        toolTop = 200;
        expandStatus = true;
        boxHeight = 456;
        activeTool = "";
        activeId = -1;
        stopCloseFlag = false;
        list = [
            {
                id: 1,
                active: false,
                lock: false,
                originPostion: {
                    left: 0,
                    top: 0,
                },
                name: "shape",
            },
            {
                id: 2,
                active: false,
                lock: false,
                originPostion: {
                    left: 0,
                    top: 0,
                },
                name: "text",
            },

            // {
            //     id: 2,
            //     active: false,
            //     lock: false,
            //     originPostion: {
            //         left: 0,
            //         top: 0,
            //     },
            //     name: "font",
            // },
            {
                id: 3,
                active: false,
                lock: false,
                originPostion: {
                    left: 0,
                    top: 0,
                },
                name: "fontColor",
            },
            {
                id: 4,
                active: false,
                lock: false,
                name: "textAlign",
                originPostion: {
                    left: 0,
                    top: 0,
                },
            },
            {
                id: 5,
                active: false,
                lock: false,
                originPostion: {
                    left: 0,
                    top: 0,
                },
                name: "fill",
            },
            {
                id: 6,
                active: false,
                lock: false,
                originPostion: {
                    left: 0,
                    top: 0,
                },
                name: "line",
            },
            {
                id: 7,
                active: false,
                lock: false,
                originPostion: {
                    left: 0,
                    top: 0,
                },
                name: "layer",
            },
            {
                id: 8,
                active: false,
                lock: false,
                originPostion: {
                    left: 0,
                    top: 0,
                },
                name: "shapeAlign",
            },
            {
                id: 9,
                active: false,
                lock: false,
                originPostion: {
                    left: 0,
                    top: 0,
                },
                name: "position",
            },
            {
                id: 10,
                active: false,
                lock: false,
                name: window["EDCONFIG"].IS_SDK ? "more" : "close",
            },
        ];

        get expandLeft() {
            return this.$store.getters.expandLeft;
        }
        get expandTop() {
            return this.$store.getters.expandTop;
        }

        get isSdk() {
            return window["EDCONFIG"].IS_SDK;
        }

        get userInfo() {
            return this.$store.state.user.userInfo;
        }

        getStyle(dom, attr) {
            return dom.currentStyle ? dom.currentStyle[attr] : getComputedStyle(dom)[attr];
        }
        setAttr(dom) {
            this.attr["left"] = parseInt(this.getStyle(dom, "left")) || 0;
            this.attr["top"] = parseInt(this.getStyle(dom, "top")) || 0;
        }
        returnAttr(dom, x, y) {
            this.toolLeft = x;
            this.toolTop = y;
        }
        drag(a, t) {
            a.onmousedown = (e) => {
                this.setAttr(t);
                document.onmousemove = (b) => {
                    var x = b.clientX - e.clientX;
                    var y = b.clientY - e.clientY;
                    this.returnAttr(t, x + this.attr["left"], y + this.attr["top"]);
                    if (b.preventDefault) {
                        b.preventDefault();
                    }
                };
                document.onmouseup = () => {
                    document.onmouseup = null;
                    document.onmousemove = null;
                    this.saveToStorage("position");
                };
            };
        }
        updateBoxPos(pos, index) {
            console.log(pos, index);
            this.list[index].originPostion = pos;
            this.saveToStorage("list");
        }
        resetData() {
            this.attr = { left: 200, top: 200 };
            this.expandStatus = true;
        }

        expandBox() {
            this.expandStatus = !this.expandStatus;
            this.boxHeight = this.expandStatus ? 456 : 56;
        }

        getColorActive(id) {
            return (id == 3 && this.fontColorWindow) || (id == 5 && this.fillColorWindow) || (id == 6 && this.lineColorWindow);
        }

        clickBox(item, e) {
            let clickLeft = e.clientX - e.offsetX + 56,
                clickTop = e.clientY - e.offsetY;
            this.activeId != item.id && this.closeBox(e.target); // 点击工具栏其他按钮时先调用关闭事件
            this.activeId = item.id;
            this.activeTool = item.name;
            let openLockBox = (index) => {
                if (this.list[index].lock) {
                } else if (this.list[index].active) {
                    this.list[index].active = false;
                    window.removeEventListener("click", this.closeBox);
                } else {
                    this.list[index].active = true;
                    this.list[index].originPostion.left = clickLeft;
                    this.list[index].originPostion.top = clickTop;
                    window.addEventListener("click", this.closeBox);
                }
            };
            switch (this.activeId) {
                case 1:
                    openLockBox(0);
                    break;
                case 2:
                    openLockBox(1);
                    break;
                case 3:
                    if (this.isSdk) {
                        openLockBox(2);
                    } else {
                        this.list[2].originPostion.left = clickLeft;
                        this.list[2].originPostion.top = clickTop;
                    }
                    this.showFontColor(e);
                    break;
                case 4:
                    openLockBox(3);
                    break;
                case 5:
                    if (this.isSdk) {
                        openLockBox(4);
                    } else {
                        this.list[4].originPostion.left = clickLeft;
                        this.list[4].originPostion.top = clickTop;
                    }
                    this.showFillColor(e);
                    break;
                case 6:
                    if (this.isSdk) {
                        openLockBox(5);
                    } else {
                        this.list[5].originPostion.left = clickLeft;
                        this.list[5].originPostion.top = clickTop;
                    }
                    this.showLineColor(e);
                    break;
                case 7:
                    openLockBox(6);
                    break;
                case 8:
                    openLockBox(7);
                    break;
                case 9:
                    if (this.isSdk) {
                        if (this.userInfo && this.userInfo.user_id !== 1) {
                            this.$bus.$emit("sdkToOnline", "pagesetting");
                        } else {
                            this.sdkApp.promisePostMessage("GOTO_LOGIN", "pagesetting");
                        }
                    } else {
                        openLockBox(8);
                    }
                    break;
                case 10:
                    if (this.isSdk) {
                        if (this.userInfo && this.userInfo.user_id !== 1) {
                            this.$bus.$emit("sdkToOnline", "more");
                        } else {
                            this.sdkApp.promisePostMessage("GOTO_LOGIN", "more");
                        }
                    } else {
                        this.$bus.$emit("exitFocus");
                    }
                    break;
                case 11:
                    openLockBox(1);
                    break;
            }
            this.saveToStorage("list");
        }
        get isSelect() {
            return !!this.$store.state.shape.isActived;
        }
        get isEDChart() {
            return window["_view"]._activeShape && window["_view"]._activeShape instanceof EDChart;
        }
        get chartIndex() {
            return this.$store.state.echart.index;
        }
        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get fontColor() {
            let color = this.$store.state.shape.fontFmt.color;
            if (color == null) {
                color = "#000";
            }
            return color;
        }
        get fillColor() {
            return this.$store.state.shape.fillFmt.colors && this.$store.state.shape.fillFmt.colors[0];
        }
        get lineColor() {
            return this.$store.state.shape.lineFmt.colors && this.$store.state.shape.lineFmt.colors[0];
        }
        get fontColorWindow() {
            return this.$store.state.ui.fontColorWindow;
        }
        get fillColorWindow() {
            return this.$store.state.ui.fillColorWindow;
        }
        get lineColorWindow() {
            return this.$store.state.ui.lineColorWindow;
        }
        showFontColor(e) {
            if (this.fontColorWindow) {
                return;
            }
            this.$store.commit("setColor", {
                type: this.fmtType.font,
                index: 0,
            });
            this.$store.commit("setStatus", {
                type: "couldFixWindow",
                data: true,
            });
            this.$store.dispatch("usePalette", {
                e,
                type: "fontColor",
                custom: true,
                left: this.list[2].originPostion.left,
                top: this.list[2].originPostion.top,
            });
        }
        showFillColor(e) {
            if (this.fillColorWindow) {
                return;
            }
            window["_view"]._tool.endEdit();
            this.$store.commit("setColor", {
                type: this.fmtType.fill,
                index: 0,
            });
            this.$store.commit("setStatus", {
                type: "couldFixWindow",
                data: true,
            });
            this.$store.dispatch("usePalette", {
                e,
                type: "fillColor",
                custom: true,
                left: this.list[4].originPostion.left,
                top: this.list[4].originPostion.top,
            });
        }
        showLineColor(e) {
            if (this.lineColorWindow) {
                return;
            }
            window["_view"]._tool.endEdit();
            this.$store.commit("setColor", {
                type: this.fmtType.line,
                index: 0,
            });
            this.$store.commit("setStatus", {
                type: "couldFixWindow",
                data: true,
            });
            this.$store.dispatch("usePalette", {
                e,
                type: "lineColor",
                custom: true,
                left: this.list[5].originPostion.left,
                top: this.list[5].originPostion.top,
            });
        }

        changeLock(index) {
            this.list[index].lock = true;
            this.saveToStorage("list");
        }
        stopCloseEvent(status) {
            this.stopCloseFlag = status;
        }
        removeCloseListener(index) {
            window.removeEventListener("click", this.closeBox);
        }
        closeEvent(index) {
            this.list[index].active = false;
            this.list[index].lock = false;
            this.saveToStorage("list");
        }
        closeBox(e) {
            let objTarget = this.$refs[this.activeTool] as HTMLElement;
            let positionBox = this.$refs.positionBox["$el"] as HTMLElement;
            let id = this.activeId;
            if (objTarget != e.target && !objTarget.contains(e.target)) {
                if (this.list[id - 1].lock) return;
                if (this.stopCloseFlag) {
                    this.stopCloseFlag = false;
                    return;
                } // 某些场景下需屏蔽关闭事件,一次性触发
                if (this.activeTool == "position" && positionBox.contains(e.target)) return;
                console.log("remove by event");
                this.list[id - 1].active = false;
                window.removeEventListener("click", this.closeBox);
                this.saveToStorage("list");
            }
        }
        get actived() {
            return this.$store.state.shape.fontFmt.actived;
        }
        get activedSize() {
            if (!this.actived) return "";
            return this.$store.state.shape.fontFmt.size;
        }
        set activedSize(v) {
            let payload = {
                type: "size",
                data: v,
            };
            this.$store.commit("setFontFmtData", payload);
        }
        addTextSize() {
            console.log("add text size");
            this.activedSize = this.activedSize + 1;
            this.activedSize = this.activedSize >= 1000 ? 1000 : this.activedSize;
            if (this.isEDChart) {
                this.ft_setChartSize(this.chartIndex, this.activedSize);
            } else if (this.isSelect) {
                this.ft_setSize(this.activedSize - 0);
            }
        }
        reduceTextSize() {
            console.log("reduce text size");
            let minFontPx = getComputedStyle(window["_view"]._measureMinFontSizeEle).fontSize.slice(0, -2);
            let minFontPt = UnitUtil.pixelToUnit(minFontPx, eUnit.pt);
            if (this.activedSize <= minFontPt) {
                let ts = this as any;
                ts.showMessage({
                    type: 2,
                    content: ts.$t("msgContent") + minFontPt + ts.$t("msgContent2"),
                });
            }
            this.activedSize = this.activedSize <= minFontPt ? minFontPt : this.activedSize - 1;
            if (this.isEDChart) {
                this.ft_setChartSize(this.chartIndex, this.activedSize);
            } else if (this.isSelect) {
                this.ft_setSize(this.activedSize - 0);
            }
        }

        saveToStorage(type) {
            let tempList = JSON.parse(JSON.stringify(this.list));
            for (let i = 0; i < tempList.length; i++) {
                if (tempList[i].active && !tempList[i].lock) {
                    tempList[i].active = false;
                }
            }
            type == "list" && localStorage.setItem("focusToolStatus", JSON.stringify(tempList));
            type == "position" && localStorage.setItem("focusToolPosition", JSON.stringify({ left: this.toolLeft, top: this.toolTop }));
        }
        loadFromStorage() {
            console.log("load from storage");
            let list = localStorage.getItem("focusToolStatus"),
                position = localStorage.getItem("focusToolPosition");
            console.log(list, position);
            list && (this.list = JSON.parse(list));
            position && ((this.toolLeft = JSON.parse(position)["left"]), (this.toolTop = JSON.parse(position)["top"]));
            this.initColorStatus();
        }
        initColorStatus() {
            // 载入颜色框锁定状态及位置
            if (this.list[2].lock == true) {
                this.$store.commit("setStatus", {
                    type: "fontColorWindow",
                    data: true,
                });
            }
            if (this.list[4].lock == true) {
                this.$store.commit("setStatus", {
                    type: "fillColorWindow",
                    data: true,
                });
            }
            if (this.list[5].lock == true) {
                this.$store.commit("setStatus", {
                    type: "lineColorWindow",
                    data: true,
                });
            }

            this.$nextTick(() => {
                this.$bus.$emit("setFixedPalettePos", {
                    type: "fontColor",
                    left: this.list[2].originPostion.left,
                    top: this.list[2].originPostion.top,
                });
                this.$bus.$emit("setFixedPalettePos", {
                    type: "fillColor",
                    left: this.list[4].originPostion.left,
                    top: this.list[4].originPostion.top,
                });
                this.$bus.$emit("setFixedPalettePos", {
                    type: "lineColor",
                    left: this.list[5].originPostion.left,
                    top: this.list[5].originPostion.top,
                });
                this.$bus.$emit("closeDefaultPalette");
            });
        }

        mounted() {
            this.drag(this.$refs.expandToolTitle, this.$refs.expandTool); // 开启拖拽
        }

        created() {
            if (this.isSdk) {
                this.toolLeft = 24;
            }
            this.loadFromStorage();
            this.$bus.$on("updateColorPos", (obj) => {
                switch (obj.type) {
                    case "fontColor":
                        this.list[2].originPostion.left = obj.left;
                        this.list[2].originPostion.top = obj.top;
                        break;
                    case "fillColor":
                        this.list[4].originPostion.left = obj.left;
                        this.list[4].originPostion.top = obj.top;
                        break;
                    case "lineColor":
                        this.list[5].originPostion.left = obj.left;
                        this.list[5].originPostion.top = obj.top;
                        break;
                }
                this.saveToStorage("list");
            });
            this.$bus.$on("updateColorLock", (obj) => {
                switch (obj.type) {
                    case "fontColor":
                        this.list[2].lock = obj.status;
                        break;
                    case "fillColor":
                        this.list[4].lock = obj.status;
                        break;
                    case "lineColor":
                        this.list[5].lock = obj.status;
                        break;
                }
                this.saveToStorage("list");
            });
        }
        beforeDestroy() {
            this.$bus.$off("updateColorPos");
            this.$bus.$off("updateColorLock");
        }
    }
</script>
<i18n>
{
  "zh": {
    "shape": "快速形状",
    "text": "插入文字",
    "font": "字体大小",
    "fontColor": "字体颜色",
    "textAlign": "文本对齐",
    "fill": "填充颜色",
    "line": "线条颜色",
    "layer": "图层",
    "shapeAlign": "对齐",
    "position": "位置",
    "msgContent": "当前浏览器最小字号为",
    "msgContent2": ",请选择其他字号或修改浏览器设置",
    "close": "退出",
    "more": "更多编辑选项"
  },
  "en": {
    "shape": "Auto Formatting",
    "text": "Insert Text",
    "font": "Font Size",
    "fontColor": "Font Color",
    "textAlign": "Text Alignment",
    "fill": "Solid Fill",
    "line": "Line Color",
    "layer": "Layers",
    "shapeAlign": "Align",
    "position": "Page Settings",
    "msgContent": "The minimum font size of the browser is",
    "msgContent2": ",Please select another font size or change the browser settings.",
    "close": "Close",
    "more": "More Features"
  },
  "fr": {
    "shape": "Formatage automatique",
    "text": "Insérer du texte",
    "font": "Taille de la police",
    "fontColor": "Couleur de la police ",
    "textAlign": "Alignement du texte",
    "fill": "Remplissage plein",
    "line": "Ligne de Couleur",
    "layer": "Calques",
    "shapeAlign": " Aligner",
    "position": "Position",
    "msgContent": "La taille de police minimale du navigateur actuel est",
    "msgContent2": ", veuillez choisir une autre taille de police ou modifier les paramètres du navigateur",
    "close": "Fermer",
    "more": "Plus"
  },
  "de": {
    "shape": "Automatische Formatierung",
    "text": "Text einfügen",
    "font": "Schriftgröße",
    "fontColor": "Schriftfarbe ",
    "textAlign": "Textausrichtung",
    "fill": "Solide ausfüllen",
    "line": "Linienfarbe",
    "layer": "Ebenen",
    "shapeAlign": "Ausrichtung",
    "position": "Position",
    "msgContent": "Die Mindestschriftgröße des aktuellen Browsers beträgt",
    "msgContent2": ", bitte wählen Sie eine andere Schriftgröße oder ändern Sie die Browsereinstellungen",
    "close": "Schließen",
    "more": "Mehr"
  },
  "jp": {
    "shape": "クイック図形",
    "text": "テキストを挿入",
    "font": "フォントサイズ",
    "fontColor": "フォントの色",
    "textAlign": "テキストの配置",
    "fill": "塗りつぶしの色",
    "line": "線の色",
    "layer": "レイヤー",
    "shapeAlign": "配置",
    "position": "位置",
    "msgContent": "現在のブラウザの最小フォントサイズは",
    "msgContent2": "、別のフォントサイズを選択するか、ブラウザの設定を変更してください",
    "close": "終了する",
    "more": "その他"
  },
  "es": {
    "shape": "Formateo Automático",
    "text": "Insertar texto",
    "font": "Tamaño de la Fuente",
    "fontColor": "Color de la Fuente ",
    "textAlign": "Alineación del Texto",
    "fill": "Relleno Sólido",
    "line": "Color de la Línea",
    "layer": "Capas",
    "shapeAlign": "Alinear",
    "position": "Posición",
    "msgContent": "El tamaño mínimo de fuente del navegador es",
    "msgContent2": "\", Selecciona otro tamaño de fuente o cambie la configuración del navegador.",
    "close": "Cerrar",
    "more": "Más"
  },
  "pt": {
    "shape": "Formatação Automática",
    "text": "Inserir texto",
    "font": "Tamanho da Fonte",
    "fontColor": "Cor da Fonte ",
    "textAlign": "Alinhamento de Texto",
    "fill": "Preenchimento Sólido",
    "line": "Cor da linha",
    "layer": "Camadas",
    "shapeAlign": " Alinhar",
    "position": " Posição",
    "msgContent": "O tamanho mínimo da fonte do navegador é",
    "msgContent2": ", Selecione outro tamanho de fonte ou altere as configurações do navegador.",
    "close": "Fechar",
    "more": "Mais"
  },
  "it": {
    "shape": "Formattazione Automatica",
    "text": "Inserisci testo",
    "font": "Dimensione del Font",
    "fontColor": "Colore del Font ",
    "textAlign": "Allineamento del Testo",
    "fill": "Riempimento Solido",
    "line": "Colore della Linea",
    "layer": "Livelli",
    "shapeAlign": " Allinea",
    "position": " Posizione",
    "msgContent": "La dimensione minima del carattere del browser è",
    "msgContent2": ", Seleziona un'altra dimensione del carattere o modifica le impostazioni del browser.",
    "close": "Chiudi",
    "more": "Altro"
  },
  "tw": {
    "shape": "自動格式化",
    "text": "插入文字",
    "font": "字體大小",
    "fontColor": "字體顏色",
    "textAlign": "文字對齊",
    "fill": "實心填滿",
    "line": "線條顏色",
    "layer": "圖層",
    "shapeAlign": "對齊",
    "position": "位置",
    "msgContent": "當前瀏覽器最小字號為",
    "msgContent2": ",請選擇其他字號或修改瀏覽器設置",
    "close": "關閉",
    "more": "更多"
  }
}
</i18n>
